const ControlButton = ({
  name,
  children,
  isActive = false,
  className,
  activeClassName,
  ...props
}: {
  name?: string;
  children: any;
  isActive?: boolean;
  activeClassName?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const defaultClasses = [
    "relative",
    "w-12",
    "h-12",
    "flex",
    "justify-center",
    "items-center",
    "rounded-lg",
    "transition-all",
  ];

  // Other classes
  const additionalClasses = className?.split(" ") || [];

  // Push items
  defaultClasses.concat(additionalClasses);

  const _activeClassName = activeClassName?.split(" ") || [
    "dark:bg-white",
    "bg-primary-blue-400",
    "dark:text-primary-blue-400",
    "text-white",
  ];

  if (isActive) {
    defaultClasses.push(..._activeClassName);
  } else if (!additionalClasses.length) {
    defaultClasses.push(
      "bg-neutral-gray-100",
      "dark:bg-neutral-gray-700",
      "dark:hover:bg-white",
      "hover:bg-primary-blue-400",
      "dark:text-white",
      "text-neutral-gray-600",
      "dark:hover:text-neutral-800",
      "hover:text-white"
    );
  }

  return (
    <button
      {...props}
      className={`${defaultClasses.join(" ")} ${className}`}
      type="button"
    >
      {children}
    </button>
  );
};

export default ControlButton;
